function handles({ domain }) {
  return domain.endsWith('vimeo.com');
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/VimeoPost/handles.js